import { render, staticRenderFns } from "./model-name-role.vue?vue&type=template&id=fac2ba50&scoped=true"
import script from "./model-name-role.vue?vue&type=script&lang=js"
export * from "./model-name-role.vue?vue&type=script&lang=js"
import style0 from "./model-name-role.vue?vue&type=style&index=0&id=fac2ba50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac2ba50",
  null
  
)

export default component.exports